export type TabId =
  | 'feed'
  | 'tree'
  | 'calendar'
  | 'search'
  | 'profile'
  | 'notifs'
  | 'history';

export const TAB_IDS: readonly TabId[] = [
  'feed',
  'tree',
  'calendar',
  'search',
  'profile',
  'notifs',
  'history',
] as const;

export type ScreenId =
  | 'item_card'
  | 'eq_card'
  | 'eq_card_draft'
  | 'new_property'
  | 'photo_eq'
  | 'catalog_eq'
  | 'out_of_catalog'
  | 'jit'
  | 'walkthrough'
  | 'videos'
  | 'season'
  | 'destruct_bulk'
  | 'destruct_cascade'
  | 'undo'
  | 'add_item'
  | 'edit_item'
  | 'edit_eq'
  | 'edit_room'
  | 'edit_property'
  | 'add_room'
  | 'regulation'
  | 'changes';

export type OverlayId = 'add_picker';

export type ScreenParams = Record<string, unknown>;

export interface StackFrame {
  readonly screen: ScreenId;
  readonly params: ScreenParams;
}

export interface RouterState {
  readonly tab: TabId;
  /**
   * Параметры, переданные в `go(tab, params)` при переходе на вкладку. Вкладки
   * не образуют стек, поэтому параметры живут отдельным полем и сбрасываются
   * при следующей навигации на любую вкладку (в т.ч. без параметров). Пример:
   * feed-карточка «ТО на неделе» открывает вкладку calendar с `{ mode: 'week' }`
   * (aidepo-63.2).
   */
  readonly tabParams: ScreenParams;
  readonly stack: readonly StackFrame[];
  readonly overlay: OverlayId | null;
}

export interface RouterApi extends RouterState {
  readonly top: StackFrame | null;
  go(screen: TabId | ScreenId, params?: ScreenParams): void;
  back(): void;
  resetTo(tab: TabId): void;
  openOverlay(id: OverlayId): void;
  closeOverlay(): void;
}

export function isTabId(s: string): s is TabId {
  return (TAB_IDS as readonly string[]).includes(s);
}
